import { render, staticRenderFns } from "./SharingLinks.vue?vue&type=template&id=79b7d028&"
import script from "./SharingLinks.vue?vue&type=script&lang=js&"
export * from "./SharingLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports